import { useSyncExternalStore } from 'react';
import {
  subscribeConnectivity,
  getConnectivitySnapshot,
  type ConnectivityStatus,
  type OutageFraming,
  type UnreachableKind,
} from './connectivityController';

export interface ConnectivitySnapshot {
  status: ConnectivityStatus;
  framing: OutageFraming;
  unreachable: boolean;
  unreachableKind: UnreachableKind;
}

/**
 * Subscribe a component to the connectivity state machine. The snapshot object
 * is referentially stable while unchanged, so this is safe for
 * `useSyncExternalStore`.
 */
export function useConnectivity(): ConnectivitySnapshot {
  return useSyncExternalStore(subscribeConnectivity, getConnectivitySnapshot, getConnectivitySnapshot);
}
